import * as React from "react";
const SvgLmsVideocamComplete = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.556 10.25V6.167c0-.642-.5-1.167-1.112-1.167H3.111C2.5 5 2 5.525 2 6.167v6.088A7 7 0 0 1 12.93 19h3.514c.612 0 1.112-.525 1.112-1.167V13.75L22 18.417V5.583l-4.444 4.667ZM0 18c0-3.312 2.688-6 6-6s6 2.688 6 6-2.688 6-6 6-6-2.688-6-6Zm1.8 0 3 3 5.4-5.4-.846-.852L4.8 19.302l-2.154-2.148L1.8 18Z",
  fill: "currentColor"
}));
export default SvgLmsVideocamComplete;